module.exports = {
	ra: {
		action: {
			add_filter: '검색기준 추가',
			add: '만들기',
			back: '돌아가기',
			bulk_actions: '1 개 선택됨 |||| %{smart_count} 개 선택됨',
			cancel: '취소',
			clear_input_value: '입력 지우기',
			clone: '복제',
			confirm: '확인',
			create: '생성',
			delete: '삭제',
			edit: '편집',
			export: '내보내기',
			list: '리스트',
			refresh: '새로고침',
			remove_filter: '이 검색기준 제거',
			remove: '제거',
			save: '저장',
			search: '검색',
			show: 'Show',
			sort: '정렬',
			undo: '취소',
			expand: '확대',
			close: '닫기',
		},
		boolean: {
			true: '예',
			false: '아니오',
		},
		page: {
			create: '%{name}을 생성',
			dashboard: '대시보드',
			edit: '%{name} #%{id}',
			error: '에러 발생!',
			list: '%{name}',
			loading: '로딩중',
			not_found: '아무것도 없습니다!',
			show: '%{name} #%{id}',
		},
		input: {
			file: {
				upload_several:
					'업로드할 파일들을 끌어다 놓거나, 클릭해서 선택하세요.',
				upload_single: '업로드할 파일을 끌어다 놓거나, 클릭해서 선택하세요.',
			},
			image: {
				upload_several:
					'업로드할 파일들을 끌어다 놓거나, 클릭해서 선택하세요.',
				upload_single: '업로드할 파일을 끌어다 놓거나, 클릭해서 선택하세요.',
			},
			references: {
				all_missing: '참조하는 데이터를 찾을 수 없습니다.',
				many_missing:
					'적어도 한 개 이상의 관련있는 데이터를 더 이상 찾을 수 없습니다.',
				single_missing:
					'관련있는 데이터를 더 이상 찾을 수 없습니다.',
			},
		},
		message: {
			about: '자세히',
			are_you_sure: '확실합니까?',
			bulk_delete_content:
				'%{name}를 삭제합니까? |||| %{smart_count} 항목을 삭제합니까?',
			bulk_delete_title:
				'%{name}를 삭제했습니다. |||| %{smart_count}개 %{name}를 삭제했습니다.',
			delete_content: '이 항목을 삭제합니까?',
			delete_title: '%{name}를 삭제했습니다. #%{id}',
			details: '세부사항',
			error:
				"클라이언트 에러가 발생해 요청한 내용을 처리할 수 없습니다.",
			invalid_form: '이 양식은 올바르지 않습니다. 오류를 체크해 주세요.',
			loading: '페이지 로딩중입니다. 잠시만 기다려 주세요',
			no: '아니오',
			not_found:
				'잘못된 URL을 입력했거나, 잘못된 링크를 사용했습니다.',
			yes: '예',
		},
		navigation: {
			no_results: '결과 없음',
			no_more_results:
				'페이지 넘버 %{page} 는 최대 범위 밖입니다. 앞의 페이지를 시도해 보십시오.',
			page_out_of_boundaries: '%{page} 페이지는 범위를 벗어났습니다.',
			page_out_from_end: '마지막 페이지로 갈 수 없습니다',
			page_out_from_begin: '1보다 작은 페이지로 갈 수 없습니다',
			page_range_info: '%{offsetBegin}-%{offsetEnd} / %{total}',
			page_rows_per_page: '페이지당 열 수:',
			next: '다음',
			prev: '이전',
		},
		auth: {
			user_menu: '프로필',
			username: 'ID',
			password: '비밀번호',
			sign_in: '로그인',
			sign_in_error: '인증에 실패했습니다. 다시 시도해 주십시오.',
			logout: '로그아웃',
		},
		notification: {
			updated: '업데이트됨 |||| %{smart_count} 개 업데이트 됨',
			created: '생성됨',
			deleted: '삭제됨 |||| %{smart_count} 개 삭제됨',
			bad_item: '잘못된 항목',
			item_doesnt_exist: '항목이 존재하지 않습니다.',
			http_error: '서버 통신 오류',
			data_provider_error:
				'데이터가 잘못 제공되었습니다. 세부사항을 확인하려면 콘솔을 참조하십시오.',
			canceled: '실행 취소됨',
			logged_out: '세션이 만료되었습니다. 다시 연결해 주십시오.',
		},
		validation: {
			required: '필수',
			minLength: '최소 %{min} 개 문자를 입력해 주십시오',
			maxLength: '최대 %{max} 개 문자를 입력해 주십시오',
			minValue: '최소 %{min}',
			maxValue: '최대 %{max}',
			number: '숫자여야 합니다',
			email: '유효한 메일이어야 합니다.',
			oneOf: '다음 중 하나여야 합니다: %{options}',
			regex: '다음 양식을 따라야 합니다 (regexp): %{pattern}',
		},
	},
};
